<div class="item-native">
  <div class="item-inner">
    <div class="input-wrapper" [class.space-between]="spaceBetween">
      <ng-content></ng-content>
    </div>
  </div>
</div>
